<script lang="ts">
    import { _ } from 'svelte-i18n';

    import QuickCategoryListItemValue from './QuickCategoryListItemValue.svelte';
    import type { QuickCategoriesIdType } from '../../Planning/QuickCategories/QuickCategoriesConfig';
    import { availableProcessStages, availableProcessStatuses } from '../../../../stores/Const';
    import { openModal } from 'svelte-modals';
    import ModalCustom from '../../../shared/Modals/ModalCustom.svelte';
    import JobHistoryWrapper from '../JobHistory/JobHistoryWrapper.svelte';
    import { features } from '../../../shared/Features/features';
    import { debug } from '../../../../stores/store';

    export let status: number;
    export let jobId: number | null = null;
    let categoryId: QuickCategoriesIdType;

    $: {
        categoryId =
            (availableProcessStages.find(s => s.id === status)?.name as QuickCategoriesIdType) ||
            'to_assign';
    }
</script>

<div>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="quick-category-details"
        title={$debug ? status.toString() : $_(categoryId)}
        on:click={() => {
            if (jobId === null) {
                console.debug('jobId is null');
                return;
            }
            if ($features.feature_1475_job_history) {
                openModal(ModalCustom, {
                    component: JobHistoryWrapper,
                    componentProps: { jobId, extended: true },
                });
            }
        }}
    >
        {#if status >= 60 && false}
            <QuickCategoryListItemValue
                showValue={true}
                title={$_(categoryId)}
                categoryId="in_progress"
                showStartArrow={true}
                showEndArrow={true}
            />
            <QuickCategoryListItemValue
                showValue={true}
                {status}
                title={$_(categoryId)}
                categoryId="in_progress"
                showStartArrow={true}
                showEndArrow={true}
                wider2={true}
            />
        {:else}
            <QuickCategoryListItemValue
                showValue={status >= 10}
                title={$_(categoryId)}
                categoryId="to_approve"
                showStartArrow={true}
                showEndArrow={true}
            />
            <QuickCategoryListItemValue
                showValue={status >= 20}
                title={$_(categoryId)}
                categoryId="to_send"
                showStartArrow={true}
                showEndArrow={true}
            />
            <QuickCategoryListItemValue
                showValue={status >= 50}
                title={$_(categoryId)}
                categoryId="in_progress"
                showStartArrow={true}
                showEndArrow={true}
            />
        {/if}
    </div>
</div>

<style>
    .quick-category-details {
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: -3px;
    }
</style>
